import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router";
import { Layout } from "./Components/Layout";
import Login from "./Pages/Login";
import { userActions } from "./_actions/user.actions";
import { connect } from "react-redux";
import "./custom.css";
import MainContainer from "./Components/MainContainer";
import { Bundles } from "./Pages/Bundles";
import { UserSummary } from "./Pages/UserSummary";
import RequestStatus from "./Pages/RequestStatus";
import { NotificationsContextProvider } from "../src/Contexts/NotificationsContext";

class App extends Component {
  static displayName = App.name;
  render() {
    let urlParameter = "";
    if (window.location.href.includes("?")) {
      if (window.location.href.split("?")[1].split("=")[0] == "page") {
        urlParameter = window.location.href.split("?")[1].split("=")[1];
      }
    } else {
      urlParameter = "bundles";
    }
    return (
      <NotificationsContextProvider>
        <Layout>
          <Switch>
            <Route
              path="/bundles"
              render={(props) => {
                return PageComponent(<Bundles />, props);
              }}
            />
            <Route
              path="/user-summary"
              render={(props) => {
                return PageComponent(<UserSummary />, props);
              }}
            />
            <Route
              path="/user-actions-summary"
              render={(props) => {
                return PageComponent(<RequestStatus />, props);
              }}
            />
            <Route
              path="/redirect"
              render={(props) => {
                return <p>Redirect Page</p>;
              }}
            />
            <Route path="/login" render={(props) => <Login directPageName={urlParameter} {...props} />}></Route>
            <Route path="*">
              <Redirect to="/user-summary" />
            </Route>
          </Switch>
        </Layout>
      </NotificationsContextProvider>
    );
  }
}

const testHeader = () => {
  if (
    process.env.REACT_APP_CWFSCORE_URL !== "https://cwfscore.gocitywide.com" &&
    process.env.REACT_APP_CWFSCORE_URL !== "https://cwfscorecloud.gocitywide.com"
  ) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <h2>TEST</h2>
      </div>
    );
  }
};

const PageComponent = (child, props) => {
  let crmUser = sessionStorage.getItem("crmUser");
  return crmUser ? (
    <>
      {testHeader()}
      <MainContainer>{child}</MainContainer>
    </>
  ) : (
    <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
  );
};

function mapStateToProps(state) {
  const { authentication } = state;
  const { crmUser, currentPage } = authentication;
  return { crmUser, currentPage };
}

const actionCreators = {
  logout: userActions.logout,
  changePage: userActions.changePage,
};

const connectedApp = connect(mapStateToProps, actionCreators)(App);
export default connectedApp;
